import styled from "@emotion/styled";
import Menu from "@mui/material/Menu";
import { Popover, TextField } from "@mui/material";

export const SearchMenuBox = styled(Popover)`
  .MuiPaper-root {
    border-radius: 15px;
    min-width: 330px;
    padding: 20px;
    overflow: visible;
    max-width: 420px;
    box-shadow: unset;
    filter: drop-shadow(0px 2px 5px rgba(0, 0, 0, 0.32));
    background-color: ${({ theme }) => theme.palette.grey.g6};
  }
`;

export const SearchTextField = styled(TextField)`
  > div {
    padding-left: 5px;
  }
  .MuiInputBase-root {
    border-radius: 30px;
    background-color: ${({ theme }) => theme.palette.grey.g5};
    input {
      padding: 13px;
    }
  }
`;

export const ChainMenuBox = styled((props) => <Menu {...props} />)(({ theme }) => ({
  "& .MuiPaper-root": {
    left: "68px !important",
    top: "12px !important",
    boxShadow: "unset",
    backgroundImage: "unset",
    borderRadius: `${theme.shape.borderRadius * 2}px`,
    marginTop: theme.spacing(1),
    backgroundColor: theme.palette.grey.g6,
    minWidth: 250,

    "& .MuiMenu-list": {
      padding: "8px",
      "& > li.active": {
        backgroundColor: theme.palette.primary.dark,
        color: theme.palette.common.white,
        borderRadius: `${theme.shape.borderRadius}px`,
      },
    },
  },
}));

export const AquaticMenuBox = styled((props) => <Menu {...props} />)(({ theme }) => ({
  "& .MuiPaper-root": {
    left: "68px !important",
    top: "130px !important",
    boxShadow: "unset",
    backgroundImage: "unset",
    borderRadius: `${theme.shape.borderRadius * 2}px`,
    marginTop: theme.spacing(1),
    backgroundColor: theme.palette.grey.g6,
    minWidth: 250,

    "& .MuiMenu-list": {
      padding: "8px",
      boxShadow:
        "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
      "& > li.active": {
        backgroundColor: theme.palette.primary.dark,
        color: theme.palette.common.white,
        borderRadius: `${theme.shape.borderRadius}px`,
      },
    },
  },
}));
